module.exports = require('promise/lib/es6-extensions')



//////////////////
// WEBPACK FOOTER
// ./node_modules/universal-promise/promise.js
// module id = 767
// module chunks = 0